import {
  groupIntoTurns,
  parseChatHistory,
} from '@/features/votes/parseChatHistory';

import TurnGroup from './TurnGroup';

interface ChatTranscriptProps {
  chatHistory: string[][];
  // Badges and highlights one message, by its chat-message id
  highlightedMessageId?: string | null;
  highlightLabel?: string;
  highlightedMessageRef?: React.Ref<HTMLDivElement>;
}

// A whole conversation rendered from the serialized history, for surfaces that
// need nothing beyond the messages. Vote pages render turns themselves because
// they interleave stored payloads and system prompts.
export default function ChatTranscript({
  chatHistory,
  highlightedMessageId,
  highlightLabel,
  highlightedMessageRef,
}: ChatTranscriptProps) {
  const messages = parseChatHistory(chatHistory);
  const highlighted = messages.find(
    (message) => message.id === highlightedMessageId
  );
  return (
    <div className="space-y-6">
      {groupIntoTurns(messages).map((turn) => (
        <TurnGroup
          key={turn.turnNumber}
          turn={turn}
          highlightedFlatIndex={highlighted?.index}
          highlightedMessageRef={highlightedMessageRef}
          highlightLabel={highlightLabel}
        />
      ))}
    </div>
  );
}
